import React, { Suspense } from 'react';

import { css } from '@compiled/react';

import { GlobalNavUserProfile } from '@/components/global-nav/user-profile-new/src/user-profile';
import { useLoggedInUser } from '@/utils/logged-in-user-provider';

import { useNavSignInPrompt } from './hooks/use-nav-sign-in-prompt';

export type NavAccountActionsProps = {
	isShowAppSwitcher?: boolean;
	isShowUserProfile?: boolean;
};

const appSwitcherContainerStyle = css({
	marginInlineEnd: '16px',
});

const navigationActionStyle = css({
	alignItems: 'center',
	display: 'flex',
	flexDirection: 'row',
	margin: 0,
	padding: 0,
});

const navigationActionLinkStyle = css({
	alignItems: 'center',
	display: 'flex',
	flexDirection: 'row',
});

const WacAppSwitcher = React.lazy(() =>
	// without the line ts-ignored below TSC throws this error:
	// "Relative import paths need explicit file extensions in EcmaScript imports when '--moduleResolution' is 'node16' or 'nodenext'. Did you mean '../../../components/global-nav/app-switcher/src/index.js'?"
	// the file of course ends in .tsx, when you try to add that there is a different error:
	// "An import path can only end with a '.tsx' extension when 'allowImportingTsExtensions' is enabled."

	import('../../../components/global-nav/app-switcher/src/app-switcher.tsx').then((module) => ({
		default: module.WacAppSwitcher,
	})),
);

export const NavAccountActions = ({
	isShowAppSwitcher = true,
	isShowUserProfile = true,
}: NavAccountActionsProps) => {
	const { isUserLoggedIn } = useLoggedInUser();
	const { isUseGeneralSigninPromptConfig, setIsUseGeneralSigninPromptConfig } =
		useNavSignInPrompt(isShowUserProfile);
	return (
		<div css={navigationActionStyle}>
			<div css={navigationActionLinkStyle}>
				<Suspense>
					{isUserLoggedIn && isShowAppSwitcher && (
						<div css={appSwitcherContainerStyle}>
							<WacAppSwitcher
								allowJoinSitesProvider={true}
								appSwitcherLabel={''}
								// @ts-expect-error type error
								appSwitcherIconPrimaryColor={'#42526e'}
								isUseV2AppSwitcherStyle={true}
								isDisplayBorderAndHoverEffect={false}
							/>
						</div>
					)}
				</Suspense>
			</div>
			{isShowUserProfile ? (
				<div css={navigationActionLinkStyle}>
					<GlobalNavUserProfile
						isUseNewLoggedInUserDropdown={true}
						isUseGeneralSigninPromptConfig={isUseGeneralSigninPromptConfig}
						setIsUseGeneralSigninPromptConfig={setIsUseGeneralSigninPromptConfig}
					/>
				</div>
			) : null}
		</div>
	);
};
